import React, {Component} from 'react';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import lazySizes from 'lazysizes';
import {isWebPAllowed} from '../../Utils/WebP';

lazySizes.cfg.preloadAfterLoad = false;
lazySizes.cfg.expFactor = 2;
lazySizes.cfg.expand = 300;
lazySizes.cfg.loadMode = 1;

class LazyImage extends Component {
  render() {
    const {className, alt, src, webp} = this.props;
    let isWebP = isWebPAllowed();
    let path = src;

    if (isWebP === true && webp) {
      path = webp;
    }

    return (
      <img alt={alt} data-src={path} className={className + " lazyload"} />
    )
  }
}

export default LazyImage;
